export default __webpack_public_path__ + "static/media/jake.ce516096.webp";